import React, { useEffect, useState } from "react";

/**
 * @param {array} options the list of options
 * @param {function} selectedValue function to pass the value selected
 * @param {string} label text to use as label
 * @param {string} customCss the css class name to have custom styles
 */
const SimpleDropdown = ({options, selectedValue, label, customCss, preset = null}) => {
    const [value, setValue] = useState("");
    const styles = {
      padding: '3px 10px',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      width: '90%'
    }
  
    if(!options) {
      options = ["No Options Found"];
    }
  
    const handleChange = (ev) => {
      if(ev.target.value === "No Options Found") {
        return;
      }
      setValue(ev.target.value);
      selectedValue(ev.target.value);
    };

    useEffect(() => {
      if(preset) {
        setValue(preset);
      }
    }, [preset])
  
    return (
      <div className={customCss ? customCss : null}>
        <label>
          {label ? label : "No Label Found"}
          <select style={styles} value={value} onChange={handleChange}>
            {value ? null : <option>Select an Option</option>}
            {options.map((option) => (
              <option value={option} key={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
      </div>
    );
  };

  export default SimpleDropdown;